import { useContext, useState } from 'react';
import Spinner from '../../../reusable/spinner/spinner.component';
import { ToastContext } from '../../../../contexts/toast.context';
import Client from '../../../../tools/client';

import {
  AddShippingButton,
  AddShippingContainer,
  AddShippingInput,
  NewShippingContainer
} from './add-shipping-provider.styles';

const client = new Client();

const AddShippingProvider = () => {
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [trackingUrlTemplate, setTrackingUrlTemplate] = useState('');
  const [loading, setLoading] = useState(false);

  const { errorToast, successToast } = useContext(ToastContext);

  const addShippingProvider = async () => {
    if (!name || !code) {
      errorToast('Name and Code are required.');
      return;
    }

    setLoading(true);

    const res = await client.createShippingProvider({
      name,
      code,
      trackingUrlTemplate
    });

    if (res.status === 400 || res.error) {
      setLoading(false);
      errorToast(res.message || 'Failed to create provider');
      return;
    }

    successToast('Shipping provider created');
    window.location.reload();
  };

  return (
    <AddShippingContainer>
      {loading ? (
        <Spinner />
      ) : (
        <NewShippingContainer>
          <AddShippingInput
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Provider Name"
          />

          <AddShippingInput
            type="text"
            name="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Code (e.g. 'UPS', 'DHL')"
          />

          <AddShippingInput
            type="text"
            name="trackingUrlTemplate"
            value={trackingUrlTemplate}
            onChange={(e) => setTrackingUrlTemplate(e.target.value)}
            placeholder="Tracking URL Template (optional)"
          />

          <AddShippingButton onClick={addShippingProvider}>Add Shipping Provider</AddShippingButton>
        </NewShippingContainer>
      )}
    </AddShippingContainer>
  );
};

export default AddShippingProvider;